import { supabase } from './supabase'

// Send notification to a specific user
export const sendNotification = async ({ userId, clubId, title, message, type, link }) => {
  await supabase.from('notifications').insert({
    user_id: userId,
    club_id: clubId,
    title,
    message,
    type,
    link: link || null,
  })
}

// Send notification to all club admins
export const notifyClubAdmins = async ({ clubId, title, message, type, link }) => {
  const { data: admins } = await supabase
    .from('supporters')
    .select('id')
    .eq('club_id', clubId)
    .eq('role', 'club_admin')

  if (!admins) return

  const notifications = admins.map(admin => ({
    user_id: admin.id,
    club_id: clubId,
    title,
    message,
    type,
    link: link || null,
  }))

  await supabase.from('notifications').insert(notifications)
}

// Send notification to all supporters of a club
export const notifyAllSupporters = async ({ clubId, title, message, type, link }) => {
  const { data: supporters } = await supabase
    .from('supporters')
    .select('id')
    .eq('club_id', clubId)
    .eq('role', 'supporter')

  if (!supporters) return

  const notifications = supporters.map(supporter => ({
    user_id: supporter.id,
    club_id: clubId,
    title,
    message,
    type,
    link: link || null,
  }))

  await supabase.from('notifications').insert(notifications)
}